import React, { useEffect, useRef } from 'react';
import svgPanZoom from 'svg-pan-zoom';
import '../styles/mapa.css';

const MapaSVG = ({ pabellonSeleccionado }) => {
  const iframeRef = useRef(null);
  const svgPanZoomInstance = useRef(null);

  useEffect(() => {
    if (!pabellonSeleccionado) return;

    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      const svg = innerDoc.querySelector('svg');

      if (svg && !svgPanZoomInstance.current) {
        svgPanZoomInstance.current = svgPanZoom(svg, {
          zoomEnabled: true,
          controlIconsEnabled: false,
          fit: true,
          center: true,
        });
      }
    };

    iframe.addEventListener('load', handleLoad);

    return () => {
      if (svgPanZoomInstance.current) {
        svgPanZoomInstance.current.destroy();
        svgPanZoomInstance.current = null;
      }
      iframe.removeEventListener('load', handleLoad);
    };
  }, [pabellonSeleccionado]);

  const handleZoomIn = () => {
    svgPanZoomInstance.current?.zoomIn();
  };

  const handleZoomOut = () => {
    svgPanZoomInstance.current?.zoomOut();
  };

  const handleReset = () => {
    svgPanZoomInstance.current?.resetZoom();
    svgPanZoomInstance.current?.center();
  };

  if (!pabellonSeleccionado) return null;

  return (
    <div>
      <div style={{ marginBottom: '1rem' }}>
        <button onClick={handleZoomIn}>➕ Zoom In</button>
        <button onClick={handleZoomOut}>➖ Zoom Out</button>
        <button onClick={handleReset}>🔄 Reset</button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
      <iframe
        ref={iframeRef}
        title="Mapa Interactivo"
        src={`/Colombiamoda/svg/pabellon_${pabellonSeleccionado}_interactivo.svg`}
        width="100%"
        height="700px"
        style={{ border: 'none' }}
      ></iframe>
      </div>
    </div>
  );
};

export default MapaSVG;


// import React, { useEffect, useRef } from 'react';
// import '../styles/mapa.css';

// const MapaSVG = ({ pabellonSeleccionado }) => {
//   const svgRef = useRef(null);

//   const fileMap = {
//     verde: '/Colombiamoda/svg/pabellon_verde_interactivo.svg',
//     amarillo: '/Colombiamoda/svg/pabellon_amarillo_interactivo.svg',
//     azul: '/Colombiamoda/svg/pabellon_azul_interactivo.svg',
//     blanco: '/Colombiamoda/svg/pabellon_blanco_interactivo.svg',
//     rojo: '/Colombiamoda/svg/pabellon_rojo_interactivo.svg',
//   };

//   useEffect(() => {
//     const svgFile = fileMap[pabellonSeleccionado];

//     if (!svgRef.current) return;

//     // Mensaje por defecto si no hay selección
//     if (!svgFile) {
//       svgRef.current.innerHTML = '<p>Selecciona un pabellón para ver el mapa.</p>';
//       return;
//     }

//     // Limpia el contenido anterior antes de cargar uno nuevo
//     svgRef.current.innerHTML = '<p>Cargando mapa...</p>';

//     // Cargar el SVG dinámicamente
//     fetch(svgFile)
//       .then((res) => res.text())
//       .then((svgContent) => {
//         svgRef.current.innerHTML = svgContent;
//       })
//       .catch((err) => {
//         svgRef.current.innerHTML = '<p>Error cargando el mapa.</p>';
//         console.error('Error al cargar el SVG:', err);
//       });
//   }, [pabellonSeleccionado]);

//   return (
//     <div className="mapa-container">
//       <div ref={svgRef} className="svg-wrapper" />
//     </div>
//   );
// };

// export default MapaSVG;


// import React, { useEffect, useRef } from 'react';
// import '../styles/mapa.css';

// const MapaSVG = ({ pabellonSeleccionado }) => {
//   const svgRef = useRef(null);

//   const fileMap = {
//     verde: '/svg/pabellon_verde_interactivo.svg',
//     amarillo: '/svg/pabellon_amarillo_interactivo.svg',
//     azul: '/svg/pabellon_azul_interactivo.svg',
//     blanco: '/svg/pabellon_blanco_interactivo.svg',
//     rojo: '/svg/pabellon_rojo_interactivo.svg',
//   };

//   useEffect(() => {
//     const svgFile = fileMap[pabellonSeleccionado];
//     if (!svgFile || !svgRef.current) {
//       svgRef.current.innerHTML = '<p>Selecciona un pabellón para ver el mapa.</p>';
//       return;
//     }

//     fetch(svgFile)
//       .then((res) => res.text())
//       .then((svg) => {
//         svgRef.current.innerHTML = svg;
//       })
//       .catch((err) => {
//         svgRef.current.innerHTML = '<p>Error cargando el mapa.</p>';
//         console.error('Error al cargar el SVG:', err);
//       });
//   }, [pabellonSeleccionado]);

//   return (
//     <div className="mapa-container">
//       <div ref={svgRef} className="svg-wrapper" />
//     </div>
//   );
// };

//export default MapaSVG;

